/**
 * DropDownList search results filtering.
 */
export const searchFilter = ({ name, dialCode }: any, searchText: string) => (
  searchText
    ? `${dialCode}${name}`.toLowerCase().includes(searchText.toLowerCase())
    : false
);
